<template>
  <ReassuranceItem has-link @click="onClick">
    <template #icon>
      <IconOfficial class="h-24 w-24 md:h-32 md:w-32" />
    </template>
    <template #title>
      {{ i18n(translations.verified) }}
    </template>
  </ReassuranceItem>
  <VerifiedRefurbishedModal :link>
    <WarrantyExclusion />
  </VerifiedRefurbishedModal>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'

import VerifiedRefurbishedModal from '@backmarket/nuxt-layer-product-modals/VerifiedRefurbishedModal.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { IconOfficial } from '@ds/icons/IconOfficial'

import { MODAL_NAMES } from '~/scopes/product/constants'
import { PRODUCT } from '~/scopes/product/route-names'

import WarrantyExclusion from '../../../WarrantyExclusion/WarrantyExclusion.vue'
import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemVerifiedRefurbished.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

const resolveLocalizedRoute = useRouteLocationWithLocale()

const link = resolveLocalizedRoute({
  name: PRODUCT.EXTERNAL_PAGE_VERIFIED_REFURBISHED,
})

function onClick(event: MouseEvent) {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED, event)
  trackClick({
    zone: 'verified_refurbished_info',
    name: 'verified_refurbished',
  })
}
</script>
